import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingTemplate from '../templates/LandingTemplate';
import SEO from '../atoms/SEO';
import { useChat } from '../../context/ChatContext';

const LandingPage = () => {
  const navigate = useNavigate();
  const { 
    setPdfContent, 
    setTutorMode, 
    resetConversation
  } = useChat();

  const handleStartClick = () => {
    // Set to tutor mode for PDF tutoring
    setTutorMode();
    
    // Navigate to chat page - conversation will start automatically
    // due to the useEffect in ChatPage
    navigate('/chat');
  };

  const handlePdfTextExtracted = (text) => {
    // Reset any existing conversation
    resetConversation();
    
    // Set the PDF content
    setPdfContent(text);
  };

  return (
    <>
      <SEO 
        title="Super Astronaut Tutor" 
        description="Learn physics, astronomy, and math with our AI science tutor." 
      />
      <LandingTemplate 
        onStartClick={handleStartClick} 
        onPdfTextExtracted={handlePdfTextExtracted}
      />
    </>
  );
};

export default LandingPage; 